var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainDiv',{attrs:{"info":_vm.block}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }